/* eslint-disable no-continue */
import { isDate } from '../../context/TranslationContext';
export var processMessages = function (messages, lastRead, userID, hideDeletedMessages, disableDateSeparator, hideNewMessageSeparator) {
    var _a, _b, _c;
    var unread = false;
    var lastDateSeparator;
    var newMessages = [];
    for (var i = 0, l = messages.length; i < l; i += 1) {
        var message = messages[i];
        if (hideDeletedMessages && message.type === 'deleted') {
            continue;
        }
        if (message.type === 'message.read') {
            newMessages.push(message);
            continue;
        }
        var messageDate = (message.created_at && isDate(message.created_at) && message.created_at.toDateString()) || '';
        var prevMessageDate = messageDate;
        var previousMessage = messages[i - 1];
        if (i > 0 &&
            !disableDateSeparator &&
            previousMessage.created_at &&
            isDate(previousMessage.created_at)) {
            prevMessageDate = previousMessage.created_at.toDateString();
        }
        if (!unread && !hideNewMessageSeparator) {
            unread = (lastRead && message.created_at && new Date(lastRead) < message.created_at) || false;
            // do not show date separator for current user's messages
            if (!disableDateSeparator && unread && ((_a = message.user) === null || _a === void 0 ? void 0 : _a.id) !== userID) {
                newMessages.push({
                    date: message.created_at,
                    id: message.id,
                    type: 'message.date',
                    unread: unread,
                });
            }
        }
        if (!disableDateSeparator &&
            (i === 0 ||
                messageDate !== prevMessageDate ||
                (hideDeletedMessages &&
                    ((_b = messages[i - 1]) === null || _b === void 0 ? void 0 : _b.type) === 'deleted' &&
                    lastDateSeparator !== messageDate)) &&
            ((_c = newMessages === null || newMessages === void 0 ? void 0 : newMessages[newMessages.length - 1]) === null || _c === void 0 ? void 0 : _c.type) !== 'message.date' // do not show two date separators in a row
        ) {
            lastDateSeparator = messageDate;
            newMessages.push({
                date: message.created_at,
                id: message.id,
                type: 'message.date',
            }, message);
        }
        else {
            newMessages.push(message);
        }
    }
    return newMessages;
};
